export default {
    ENROLMENTS_TAB: 'ENROLMENTS_TAB',
    COHORTS_TAB: 'COHORTS_TAB',
    PAYMENTS_TAB: 'PAYMENTS_TAB',
    COURSES_TAB: 'COURSES_TAB',
    FAILED_PAYMENT_PROCESSES_TAB: 'FAILED_PAYMENT_PROCESSES_TAB',
    IMPERSONATION_TAB: 'IMPERSONATION_TAB',
};
